import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ReportService from "services/ReportService";

export const initialState = {
  testLevelPriceList: [],
  dailyReportList: [],
  dailyReportLoading: false,
  testLevelPriceLoading: false,
  errorMessages: [],
  actualPatientCount: 0,
  eachTestData: [],
  agencyList: [],
  agencyData: null,
  showMessage: false,
};

export const fetchTestPriceReport = createAsyncThunk(
  "/fetchTestPriceReport",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("Payload in report slice:", payload);
      const response = await ReportService.fetchTestLevelReport(payload);
      const code = response.code;
      return {
        code: code,
        report: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);

export const fetchDailyReport = createAsyncThunk(
  "/fetchDailyReport",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ReportService.fetchDailyReport(payload);
      const code = response.code;
      return {
        code: code,
        report: response.data.data,
        actualPatientCount: response.data.actualPatientCount || 0,
        eachTestData: response.data.eachTestData || [],
        agencyData: response.data.agencyData || null,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);

export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.testLevelPriceLoading = !state.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestPriceReport.pending, (state) => {
        state.testLevelPriceLoading = true;
      })
      .addCase(fetchTestPriceReport.fulfilled, (state, action) => {
        state.testLevelPriceLoading = false;
        state.testLevelPriceList = action.payload.report;
      })
      .addCase(fetchTestPriceReport.rejected, (state, action) => {
        state.testLevelPriceLoading = false;
        state.testLevelPriceList = [];
      })
      .addCase(fetchDailyReport.pending, (state) => {
        state.dailyReportLoading = true;
      })
      .addCase(fetchDailyReport.fulfilled, (state, action) => {
        state.dailyReportLoading = false;
        state.dailyReportList = action.payload.report;
        state.actualPatientCount = action.payload.actualPatientCount || 0;
        state.eachTestData = action.payload.eachTestData || [];
        state.agencyData = action.payload.agencyData || null;
      })
      .addCase(fetchDailyReport.rejected, (state, action) => {
        state.dailyReportLoading = false;
        state.dailyReportList = [];
      });
  },
});

export const { showLoading } = reportSlice.actions;

export default reportSlice.reducer;
